import type { ReactNode } from "react";
import { ClientErrorBoundary } from "../../../../../../shared/frontend/feedback/ClientErrorBoundary";
import { requestManualAppReload } from "../system/appReloadCoordinator";
import { showClientErrorDetails, useClientErrorRecoveryLabels } from "./clientErrorRecovery";
import { postClientErrorOnce } from "./clientErrorReporter";

export function ErrorBoundary({ children }: { children: ReactNode }) {
  const labels = useClientErrorRecoveryLabels();
  return (
    <ClientErrorBoundary
      labels={labels}
      reportError={postClientErrorOnce}
      showDeveloperDetails={showClientErrorDetails()}
      onBackToDashboard={() => { window.location.hash = "#/dashboard"; }}
      onReload={requestManualAppReload}
    >
      {children}
    </ClientErrorBoundary>
  );
}
